<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" (ngModelChange)="changeEvent()" class="main-border-class"
          [max]="today" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" (ngModelChange)="changeEvent()" class="main-border-class"
          [min]="from_date" />
      </div>
      <div class="col-3">
        <mat-label>Route &nbsp; <mat-checkbox (change)="checkboxChanged($event)" checked="true">All</mat-checkbox>
        </mat-label>
        <mat-select multiple style="border-radius: 10px; border: 1px solid black; padding: 17px;"
          [(ngModel)]="selected_route_list" [disabled]="route_disabled" (ngModelChange)="changeEvent()">
          <mat-option *ngFor="let route of routes" [value]="route.id">{{route.name}}</mat-option>
        </mat-select>
      </div>
      <!-- <div class="col-3">
        <mat-label>Selecte Product</mat-label>
        <mat-select [(ngModel)]="selected_product_option" (ngModelChange)="changeEvent()" class="main-border-class">
          <mat-option value="milk">Milk</mat-option>
          <mat-option value="curd">Fermented Product</mat-option>
        </mat-select>
      </div> -->
    </div><br>
    <hr style="background: white;">
    <div class="row">
      <div class="col">
        <mat-radio-group aria-label="Select an option" [(ngModel)]="seleted_option_type"
          (ngModelChange)="changeEvent()">
          <div class="row">
            <div class="col-8">
              <mat-radio-button value="by_business_type" checked><label style="font-size: 20px;">By Institution
                  Type</label></mat-radio-button>
              <mat-radio-button value="by_business" style="padding-left: 38px;"><label style="font-size: 20px;">By Booth
                  Number</label></mat-radio-button>
            </div>
            <div class="col-4"></div>
          </div>
        </mat-radio-group>
      </div>
    </div><br>
    <div class="row">
      <div class="col-3" *ngIf="seleted_option_type == 'by_business'">
        <input type="text" style="border: 1px solid;border-radius: 14px;padding: 10px;"
          [(ngModel)]="entered_booth_number" /><br>
        <label style="color: red;">*Comma seperated booth number</label>
      </div>
    </div>
    <div class="row" *ngIf="seleted_option_type == 'by_business_type'">
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'private_institute')">Private Institute</mat-checkbox>
      </div>
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'govt_institute')">Govt Institute</mat-checkbox>
      </div>
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'union_parlour')">Union Parlour</mat-checkbox>
      </div>
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'society')">Society</mat-checkbox>
      </div>
    </div><br>
    <div class="row" *ngIf="seleted_option_type == 'by_business_type'">
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'union_booth')">Union Booth</mat-checkbox>
      </div>
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'nilgris')">Nilgris</mat-checkbox>
      </div>
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'tirupur')">Tirupur</mat-checkbox>
      </div>
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'reliance')">Reliance</mat-checkbox>
      </div>
    </div><br>
    <div class="row" *ngIf="seleted_option_type == 'by_business_type'">
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'booth')">Booth</mat-checkbox>
      </div>
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'wsd')">Wholesale Dealer</mat-checkbox>
      </div>
      <div class="col-2">
        <mat-checkbox (change)="businessTypeOptionChanged($event, 'stockiest')">Stockiest</mat-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;">Booths To
          Exclude</label>&nbsp;&nbsp;<span style="color: #aea9a9;">Enter
          comma
          seperated values</span>
      </div>
      <div class="col" style="text-align: right;">
        <label style="margin-right: 9%;font-size: 17px; color: firebrick;">{{exclude_booth_code_list.length}}
          Booths</label>
      </div>
    </div>

    <div class="row">
      <div class="col" style="border: 1px solid; padding: 10px; overflow: auto; height: 200px;">
        <mat-chip-list #chipList>
          <mat-chip *ngFor="let booth of exclude_booth_code_list" [selectable]="selectable" [removable]="removable"
            (removed)="removeBoothCalled(booth)">
            {{booth}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input #fruitInput [(ngModel)]="entered_booth_code_for_exclude" [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addNewBoothCalledForExclude()">
        </mat-chip-list>
      </div>
    </div>
    <hr style="background: white;">

    <div class="row">
      <div class="col-2">
        <button (click)="getClicked()" style="font-size: 27px;border-radius: 5px;background: blanchedalmond;"
          [disabled]="to_date == null || from_date == null">Get</button>
      </div>

      <div *ngIf="!is_document_available" class="col-2">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>

      <div class="col-2" *ngIf="document_file!== null">
        <button mat-button class="button-class" (click)="downloadClickedForPdf()" style="margin-top: 7px;"><i
            class="material-icons">
            picture_as_pdf
          </i> Download report</button>
      </div>

    </div>
  </div>
</section>